module.exports = __webpack_public_path__ + "img/man.f289efaa.svg";